export const LOGIN_USER_REQUEST = 'login/user/request';
export const LOGIN_USER_SUCCESS = 'login/user/success';
export const LOGIN_USER_FAILURE = 'login/user/failure';

export const RESTORE_SESSION_SUCCESS = 'restore/session/success';

export const SIGN_UP_REQUEST = "SIGN_UP_REQUEST";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_FAILURE = "SIGN_UP_FAILURE";


export const LOGOUT_USER = 'logout/user';